export { PromiseMerger as default } from 'choerodon-ui/dataset';
